//import axios from 'axios';

import HTTP from './http';

export default {
  post(options) {
    return HTTP.post(`/${options.endpoint}`, options.data);
  },
};
